const handlePageNumberChange = function wrapper(table) {
  return function HandlePageNumberChange(pageNumber) {
    this.props.setAppState({
      [table]: {
        ...this.props.data,
        shouldLoad: true,
        pageNumber,
      },
    });
  };
};

const handlePageSizeChange = function wrapper(table) {
  return function HandlePageSizeChange(e) {
    this.props.setAppState({
      [table]: {
        ...this.props.data,
        shouldLoad: true,
        pageSize: Number(e.target.value),
        pageNumber: 1,
      },
    });
  };
};

export {
  handlePageNumberChange,
  handlePageSizeChange,
};



// WEBPACK FOOTER //
// ./src/helpers/pagination.js